export default {"src":"/_next/static/media/icon_play_practive_v2.c1a41a9f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};